import * as Period from 'constants/Period';

const HANDBALL_PERIOD_MAP = {};
HANDBALL_PERIOD_MAP[1900] = Period.NOT_STARTED;
HANDBALL_PERIOD_MAP[1901] = Period.FIRST;
HANDBALL_PERIOD_MAP[1902] = Period.FIRST_BREAK;
HANDBALL_PERIOD_MAP[1903] = Period.SECOND;
HANDBALL_PERIOD_MAP[1904] = Period.FULL_TIME;
HANDBALL_PERIOD_MAP[1905] = Period.FINISHED;

export default HANDBALL_PERIOD_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Handball/PeriodMap.js